<template>
  <div v-if="tipo" class="card card-body shadow-sm mt-0">
    <div class="form-header d-flex justify-content-between align-items-center">
      <h4 class="form-title">Detalhes do Tipo de Pagamento</h4>
      <router-link to="/financeiro/parametros/tipos">
        <button class="btn btn-secondary btn-sm">Voltar</button>
      </router-link>
    </div>

    <div class="form-content mt-3">
      <FormSection title="">
        <p><strong>Operador:</strong> {{ tipo.nome_operador || 'Não informado' }}</p>
        <p><strong>Meio:</strong> {{ tipo.nome_meio || 'Não informado' }}</p>
        <p><strong>Forma:</strong> {{ tipo.nome_forma || 'Não informado' }}</p>
        <p><strong>Tipo:</strong> {{ tipo.tipo || 'Não informado' }}</p>
        <p><strong>Criado em:</strong> {{ formatDate(tipo.criado_em) }}</p>
        <p><strong>Atualizado em:</strong> {{ formatDate(tipo.atualizado_em) }}</p>
      </FormSection>
    </div>
  </div>

  <div v-else>
    <LoadingSpinner />
  </div>
</template>

<script>
import axios from "@/services/axios";
import FormSection from "@/components/Layout/FormSection.vue";

export default {
  components: { FormSection },
  data() {
    return {
      tipo: null,
    };
  },
  methods: {
    async carregarDetalhesTipo() {
      try {
        const response = await axios.get(
          `/financeiro/parametros/tipos/${this.$route.params.id}`
        );
        this.tipo = response.data;
      } catch (error) {
        console.error("Erro ao carregar os detalhes do tipo:", error);
      }
    },
    formatDate(data) {
      if (!data) return "Não informado";
      return new Date(data).toLocaleString();
    },
  },
  mounted() {
    this.carregarDetalhesTipo();
  },
};
</script>

<style scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
}
.form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0rem;
}
.form-header h4 {
  margin: 0;
  font-weight: bold;
  text-align: left;
}
.form-content {
  margin-top: 1.5rem;
}
button.btn-sm {
  padding: 6px 12px;
}
</style>
